import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import { selectCurrentUser } from "@/redux/authentication/selectors";
import { useDataBlockPermissions } from "@/domains/datablocks/hooks/useDataBlockPermissions";
import { DataBlockSidebarProps } from "@/features/datablocks/details/types";
import Versions from "@/features/datablocks/details/components/Versions";
import BaseTabs from "@/components_v2/Tabs/BaseTabs";
import Contributors from "@/features/datablocks/details/components/Contributors";
import History from "@/features/datablocks/details/components/History";

import "../styles.css";

const DataBlockSidebar = ({
  dataBlock,
  dataTemplate,
  showCtas,
}: DataBlockSidebarProps) => {
  const { t } = useTranslation();
  const currentUser = useSelector(selectCurrentUser);
  const { canEdit } = useDataBlockPermissions({
    dataBlock,
    dataTemplate,
    currentUser,
  });

  const tabs = [
    {
      key: "contributors",
      label: t("datablocks.labels.contributors"),
      children: (
        <Contributors
          dataBlock={dataBlock}
          canEdit={canEdit}
          showCtas={showCtas}
        />
      ),
    },
    {
      key: "versions",
      label: t("datablocks.labels.referencesAndEditions"),
      children: <Versions dataBlockId={dataBlock.id} />,
    },
    ...(dataBlock.editable
      ? [
          {
            key: "history",
            label: t("datablocks.labels.history"),
            children: <History dataBlockId={dataBlock.id} />,
          },
        ]
      : []),
  ];

  return (
    <div className="data-block-sidebar flex flex-col gap-400 full-height scrollbar-neutral">
      <BaseTabs items={tabs} defaultActiveKey="contributors" />
    </div>
  );
};

export default DataBlockSidebar;
